// Hardcoded legacy marketing IDs (mirrors old Vue app)
export const GTM_CONTAINER_ID = "GTM-MJPJFL8D";
export const GA4_MEASUREMENT_ID = "G-W0BXE7E93F";
export const META_PIXEL_ID = "944762766761206";




